
import { Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { RelatoriosService } from './relatorios.service';
import { finalize } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RelatorioEntregasArquivosComponent } from './relatorio-entregas-arquivos/relatorio-entregas-arquivos.component';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'app/core/security/authentication-service';
import RelatorioUtils from 'app/shared/sefaz/relatorio-util';

@Component({
  selector: 'app-emitir-relatorios',
  templateUrl: './emitir-relatorios.component.html',
  styleUrls: ['./emitir-relatorios.component.scss']
})
export class EmitirRelatoriosComponent {

  uriOmissao = '/relatorio_omissoes_obrigacoes_acessorias.pdf';

  constructor (
    private spinner: NgxSpinnerService,
    private relatoriosService: RelatoriosService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    public authService: AuthenticationService
  ) {}
  
  public emitirOmissoes(): void {
      try {

        if (!AuthenticationService.temPermissaoParaEmitirRelatorioOmissao("Você não tem permissão para emitir relatório de omissoes.")) {
          return;
        }

        this.spinner.show();
        const nomeUsuario = this.authService.getUsuarioSessao();

        this.relatoriosService.downloadRelatorio({nomeUsuario}, this.uriOmissao).subscribe(
            (res: any) => {
                RelatorioUtils.downloadPdf(res, 'relatorio-omissao.pdf')
                    .pipe(
                        finalize((): void => {
                            this.spinner.hide();
                        }),
                        )
                    .subscribe({
                    next: (ret: any) => {
                        this.toastr.success('Relatório gerado com sucesso!', 'Sucesso');
                        this.spinner.hide();
                    },
                    error: (error: any) => {
                        this.toastr.error('Erro ao gerar relatório', "Erro");
                        this.spinner.hide();
                    }
                });
            },
            (error: any) => {
                this.toastr.error('Erro durante a geração do relatório', "Erro");
                this.spinner.hide();
            }
        );
      } catch (error: any) {
          this.toastr.error( error.message, "Erro");
          this.spinner.hide();
      }
  }

  emitirEntregasArquivos() : void {

    if (!AuthenticationService.temPermissaoParaEmitirRelatorioEntregaArquivos("Você não tem permissão para emitir relatório de Entregas de Arquivos.")) {
        return;
    }

    this.modalService.open(RelatorioEntregasArquivosComponent, {
        backdrop: 'static',
        windowClass: 'xlModal',
        size: 'lg'
    });
  }

}
